"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const QueryStringHelper_1 = __importDefault(require("./QueryStringHelper"));
const PeakAuthConstants_1 = __importDefault(require("./PeakAuthConstants"));
class PeakAuthQueryStrings {
    static GetBooleanQueryString(name) {
        let b = QueryStringHelper_1.default.Get(name);
        if (b === null)
            return undefined;
        return b === 'true';
    }
    static get service() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.service); }
    static get code() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.code); }
    static get refreshCode() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.refreshCode); }
    static get autoLogin() { return PeakAuthQueryStrings.GetBooleanQueryString(PeakAuthConstants_1.default.autoLogin); }
    static get requestCode() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.requestCode); }
    static get redirectUri() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.redirectUri); }
    static get loginHint() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.loginHint); }
    static get status() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.status); }
    static get adminConsent() { return PeakAuthQueryStrings.GetBooleanQueryString(PeakAuthConstants_1.default.adminConsent); }
    static get with() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.with); }
    static get error() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.error); }
    static get process() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.process); }
    static get source() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.source); }
    static get sourceIdentifier() { return QueryStringHelper_1.default.Get(PeakAuthConstants_1.default.sourceIdentifier); }
}
exports.default = PeakAuthQueryStrings;
